import React from 'react';

function NavigationIcon({ width = 10, height = 10, ...props}) {
  return (
    <svg width={width} height={height} {...props} viewBox="0 0 10 10">
      <g>
        <polygon points="0 4.54545455 5.65217391 4.54545455 5.65217391 10 10 0" />
      </g>
    </svg>
  );
}

export default NavigationIcon;
